import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import {Link} from 'react-router-dom';
import {parseDate} from './helper-lib.js';
import Underliner from './underliner.js';

class NewsGrid extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gridActive: false
    }
  }

  onMouseEnter = (e) => {
    this.setState({
      gridActive: true
    })
  }

  onMouseLeave = (e) => {
    console.log('left');
    this.setState({
      gridActive: false
    })
  }

  render() {
    const posts = DataStore.getAllPosts();

    return (
      <section className={`post-grid ${this.state.gridActive ? 'post-grid-active' : ''}`}>
        <div className="cnt">
          <div className="cnt">
          {posts.map((post, i)=>{
            return <Link to={`/news/${post.slug}`}
                        key={i}
                        className="post"
                        onMouseEnter={this.onMouseEnter}
                        onMouseLeave={this.onMouseLeave}
                    >
              <div className="thumb">
              {post.acf.image !== null & post.acf.image !== undefined && post.acf.image ?
                <img src={post.acf.image.url} alt={post.acf.image.title} />:null }
              </div>
              <div className="description">
                <div className="date">{parseDate(post.date)}</div>
                <div className="title" dangerouslySetInnerHTML={{__html: post.title.rendered}} />
                <Underliner>
                  <div className="more">View More</div>
                </Underliner>
              </div>

              <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
            </Link>
          })}
            <div className="mobile-crosses">
              <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
              <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default NewsGrid;



// WEBPACK FOOTER //
// ./src/scripts/components/news-grid.js